<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">CAMBIO DE CONTRASEÑA</h1>
    </section>

    <form [formGroup]="passwordForm" (ngSubmit)="saveChanges(passwordForm.value)">
      <mat-card>
        <div fxLayout="column" fxLayoutAlign="space-evenly stretch">

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Contraseña Actual</mat-label>
              <input type="password" matInput formControlName="dsPassword">
              <mat-error *ngIf="passwordForm.controls['dsPassword'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Nueva Contraseña</mat-label>
              <input type="password" matInput formControlName="dsNewPassword">
              <mat-error *ngIf="passwordForm.controls['dsNewPassword'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="passwordForm.controls['dsNewPassword'].hasError('minLength')">
                Debe contener mínimo 8 caracteres
              </mat-error>
              <mat-error *ngIf="passwordForm.controls['dsNewPassword'].hasError('cannotContainSpace')">
                No puede comenzar con un espacio en blanco
              </mat-error>
              <mat-hint>Debe contener mínimo 8 caracteres</mat-hint>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Repetir Nueva Contraseña</mat-label>
              <input type="password" matInput formControlName="confirmNew">
              <mat-error *ngIf="passwordForm.controls['confirmNew'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="passwordForm.controls['confirmNew'].hasError('passDistinta')">
                Las contraseñas no coinciden
              </mat-error>
            </mat-form-field>
          </div>

        </div>
      </mat-card>
      <br>

      <div fxLayout="row" fxLayoutAlign="start center">

        <button type="submit" mat-raised-button [disabled]="!passwordForm.valid" class="save-changes">
          CONFIRMAR CAMBIOS
        </button>
        <button routerLink="/admin-home" mat-raised-button class="cancel-changes">CANCELAR</button>

      </div>
    </form>
  </div>
</div>
